/**
 * List of constants required for ensighten tagging, we will be using on page level components to update jcpDl object
 */
const constants = {
    COUPON_PAGE_ID: 'promotions',
    COUPON_PAGE_NAME: 'jcp coupon',
    siteSection: {
        COUPON: 'promotion',
    },
    COUPON: 'COUPON',
    YES: 'yes',
    NO: 'no',
    ZERO: '0.00',
    EMPTY: '',
    TOF: 'tof',
};

export default constants;
